(function($){ $(function(){
    
    $('#billboard') 
	.before('<div id="billboardNav">') 
	.cycle({ 
	    fx: 'fade', 
	    speed: 1500, 
	    timeout: 5000, 
	    pager: '#billboardNav',
		pause: true,
		pauseOnPagerHover: true,
		slideExpr: '.slide',
		cleartype: true,
		cleartypeNoBg: true
	});

}); })(jQuery)
